import { defineAsyncComponent } from 'vue';

const SUTransferDetail = defineAsyncComponent(() => import('@/views/tools/sUTransfer/SUTransferDetail.vue'));
const SUIncrementDetail = defineAsyncComponent(() => import('@/views/tools/sUIncrement/SUIncrementDetail.vue'));
const SUDecrementDetail = defineAsyncComponent(() => import('@/views/tools/sUDecrement/SUDecrementDetail.vue'));
const TransferToolErrorPopup = defineAsyncComponent(() =>
  import('@/views/tools/sUTransfer/TransferToolErrorPopup.vue')
);
const ApproveVoucherSUTransferList = defineAsyncComponent(() =>
  import('@/views/tools/sUTransfer/ApproveVoucherSUTransferList.vue')
);
const ApproveVoucherSUDecrementList = defineAsyncComponent(() =>
  import('@/views/tools/sUDecrement/ApproveVoucherSUDecrementList.vue')
);
const ApproveVoucherSUIncrementList = defineAsyncComponent(() =>
  import('@/views/tools/sUIncrement/ApproveVoucherSUIncrementList.vue')
);

export function registerSU(app) {
  app.component('SUTransferDetail', SUTransferDetail);
  app.component('SUIncrementDetail', SUIncrementDetail);
  app.component('SUDecrementDetail', SUDecrementDetail);
  app.component('TransferToolErrorPopup', TransferToolErrorPopup);
  app.component('ApproveVoucherSUTransferList', ApproveVoucherSUTransferList);
  app.component('ApproveVoucherSUDecrementList', ApproveVoucherSUDecrementList);
  app.component('ApproveVoucherSUIncrementList', ApproveVoucherSUIncrementList);
}
